import WalletManager from './walletmanager.js';
import NETWORKS from './networkconfig.js';
import { fetchGalleryTokenIds, fetchGalleryTokenMetadata, isWalletOwnerOfToken } from './gallery.js';
import { initEscrow, takerDeposit, cancelEscrow, fetchOpenEscrows, makerApprove, isOperatorForToken } from './swapmeet.js';

const walletAddressDiv = document.getElementById('walletAddress');
const connectWalletBtn = document.getElementById('connectWalletBtn');
const disconnectWalletBtn = document.getElementById('disconnectWalletBtn');
const networkRadios = document.querySelectorAll('input[name="network"]');
const fetchTokensBtn = document.getElementById('fetchTokensBtn');
const sendOfferBtn = document.getElementById('sendOfferBtn');
const clearMakerBtn = document.getElementById('clearMakerBtn');
const findOffersBtn = document.getElementById('findOffersBtn');

const makerContractInput = document.getElementById('makerContractAddress');
const artistAddressInput = document.getElementById('artistAddress');
const quantitySelect = document.getElementById('tokenQuantity');
const makerTokensGrid = document.getElementById('makerTokensGrid');

const allOffersGrid = document.getElementById('allOffersGrid');

const statusModal = document.getElementById('statusModal');
const modalStatusText = document.getElementById('modalStatusText');
const modalLoadingAnimation = document.getElementById('modalLoadingAnimation');
const modalCloseBtn = document.getElementById('modalCloseBtn');

const operatorCheckModal = document.getElementById('operatorCheckModal');
const operatorModalMessage = document.getElementById('operatorModalMessage');
const operatorModalError = document.getElementById('operatorModalError');
const operatorModalRetryBtn = document.getElementById('operatorModalRetryBtn');
const operatorModalCancelBtn = document.getElementById('operatorModalCancelBtn');

const takerContractInput = document.getElementById('takerContractAddress');
const takerTokensGrid = document.getElementById('takerTokensGrid');
const fetchTakerTokensBtn = document.getElementById('fetchTakerTokensBtn');
const takerSection = document.getElementById('takerSection');
const depositOfferBtn = document.getElementById('depositOfferBtn');

let walletManager = null;
let selectedNetwork = 'mainnet';
let connectedAddress = null;
let makerTokens = [];
let selectedTokenId = null;
let selectedTokenMaxAmount = 1;
let selectedTakerTokenId = null;
let selectedTakerTokenMaxAmount = 1;
let selectedEscrowId = null;
let selectedEscrowRole = null;
let selectedEscrowState = null;
let lastEscrowSubmission = null;

function getSelectedNetwork() {
  return document.getElementById('networkMainnet').checked ? 'mainnet' : 'ghostnet';
}

function openModal(message) {
  modalStatusText.textContent = message;
  modalLoadingAnimation.style.display = 'block';
  modalCloseBtn.style.display = 'none';
  statusModal.style.display = 'flex';
}

function closeModal() {
  statusModal.style.display = 'none';
  modalCloseBtn.style.display = 'none';
  modalLoadingAnimation.style.display = 'block';
  modalStatusText.textContent = '';
}

modalCloseBtn.addEventListener('click', closeModal);

operatorModalRetryBtn.addEventListener('click', () => {
  operatorModalError.style.display = 'none';
  operatorCheckModal.style.display = 'none';
  if (lastEscrowSubmission) lastEscrowSubmission();
});

operatorModalCancelBtn.addEventListener('click', () => {
  operatorModalError.style.display = 'none';
  operatorCheckModal.style.display = 'none';
  lastEscrowSubmission = null;
});

connectWalletBtn.addEventListener('click', async () => {
  const newlySelectedNetwork = getSelectedNetwork();
  if (walletManager && walletManager.getNetwork() !== newlySelectedNetwork) {
    await walletManager.disconnect();
    window.location.reload();
    return;
  }

  selectedNetwork = newlySelectedNetwork;
  walletManager = new WalletManager(selectedNetwork);

  try {
    connectedAddress = await walletManager.connect();
    walletAddressDiv.textContent = `Connected: ${connectedAddress}`;
    clearMakerBtn.disabled = false;
    findOffersBtn.disabled = false;
    connectWalletBtn.style.display = 'none';
    disconnectWalletBtn.style.display = 'inline-block';
    findOffersBtn.click();	
  } catch (err) {
    walletAddressDiv.textContent = 'Wallet connection failed';
    console.error(err);
  }
});

disconnectWalletBtn.addEventListener('click', async () => {
  if (!walletManager) return;
  try {
    await walletManager.disconnect();
    connectedAddress = null;
    walletManager = null;
    walletAddressDiv.textContent = 'Disconnected';
    clearMakerBtn.disabled = true;
    findOffersBtn.disabled = true;
    connectWalletBtn.style.display = 'inline-block';
    disconnectWalletBtn.style.display = 'none';

    resetMakerForm();
    resetOffersGrids();
  } catch (err) {
    console.error('Disconnect error:', err);
  }
});

fetchTokensBtn.addEventListener('click', async () => {
  if (!walletManager || !connectedAddress) {
    alert('Connect wallet first');
    return;
  }
  const contractAddr = makerContractInput.value.trim();
  if (!contractAddr) {
    alert('Enter contract address');
    return;
  }

  openModal('Fetching your tokens…');
  try {
    makerTokensGrid.innerHTML = '';
    artistAddressInput.value = '';
    quantitySelect.disabled = true;
    sendOfferBtn.disabled = true;
    selectedTokenId = null;

    const tokenIds = await fetchGalleryTokenIds(selectedNetwork, contractAddr);
    const ownedTokenIds = [];
    const total = tokenIds.length;
    let checked = 0;
    let found = 0;

    for (const tokenId of tokenIds) {
      checked++;
      modalStatusText.textContent = `Fetching your tokens…\nChecked: ${checked} / ${total}\nFound: ${found}`;
      if (await isWalletOwnerOfToken(connectedAddress, tokenId, selectedNetwork, contractAddr)) {
        ownedTokenIds.push(tokenId);
        found++;
      }
      modalStatusText.textContent = `Fetching your tokens…\nChecked: ${checked} / ${total}\nFound: ${found}`;
    }

    if (!ownedTokenIds.length) {
      closeModal();
      alert('You own no tokens in this contract');
      return;
    }

    const tokensWithMetadata = await Promise.all(
      ownedTokenIds.map(tokenId => fetchGalleryTokenMetadata(tokenId, selectedNetwork, contractAddr))
    );

    makerTokensGrid.innerHTML = '';
    tokensWithMetadata.forEach(token => {
      const div = document.createElement('div');
      div.className = 'token-item';

      const label = document.createElement('label');
      label.textContent = `ID: ${token.tokenId}`;
      label.style.fontSize = '0.7em';
      label.style.fontWeight = 'bold';
      label.style.marginBottom = '5px';

      const img = document.createElement('img');
      img.src = token.img || 'placeholder.png';
      img.alt = token.name || 'Token Image';
      img.style.maxWidth = '140px';
      img.style.display = 'block';
      img.style.borderRadius = '3px';

      const nameLabel = document.createElement('label');
      nameLabel.textContent = token.name || 'Untitled';
      nameLabel.style.fontSize = '0.7em';
      nameLabel.style.marginTop = '5px';
      nameLabel.style.wordWrap = 'break-word';

      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'makerToken';
      radio.value = token.tokenId;
      radio.style.marginTop = '8px';

      radio.addEventListener('change', () => {
        selectedTokenId = parseInt(radio.value);
        console.log('Token selected, selectedTokenId set to:', selectedTokenId);
        selectedTokenMaxAmount = 1;

        const firstCreator = Array.isArray(token.creators) && token.creators.length > 0 
          ? token.creators[0] 
          : '';

        artistAddressInput.value = firstCreator;

        quantitySelect.disabled = false;
        quantitySelect.innerHTML = '';
        for (let i = 1; i <= selectedTokenMaxAmount; i++) {
          const option = document.createElement('option');
          option.value = i;
          option.textContent = i;
          quantitySelect.appendChild(option);
        }
        sendOfferBtn.disabled = false;
      });

      div.appendChild(label);
      div.appendChild(img);
      div.appendChild(nameLabel);
      div.appendChild(radio);

      makerTokensGrid.appendChild(div);
    });
    
    setTimeout(() => closeModal(), 500);

  } catch (err) {
    console.error(err);
    modalLoadingAnimation.style.display = 'none';
    modalStatusText.textContent = 'Failed to fetch or display owned tokens: ' + err.message;
    setTimeout(() => closeModal(), 2500);
  }
});

fetchTakerTokensBtn.addEventListener('click', async () => {
  if (!walletManager || !connectedAddress) {
    alert('Connect wallet first');
    return;
  }
  const contractAddr = takerContractInput.value.trim();
  if (!contractAddr) {
    alert('Enter contract address');
    return;
  }

  openModal('Fetching your tokens…');
  try {
    takerTokensGrid.innerHTML = '';
    depositOfferBtn.disabled = true;
    selectedTakerTokenId = null;

    const tokenIds = await fetchGalleryTokenIds(selectedNetwork, contractAddr);
    const ownedTokenIds = [];
    const total = tokenIds.length;
    let checked = 0;
    let found = 0;

    for (const tokenId of tokenIds) {
      checked++;
      modalStatusText.textContent = `Fetching your tokens…\nChecked: ${checked} / ${total}\nFound: ${found}`;
      if (await isWalletOwnerOfToken(connectedAddress, tokenId, selectedNetwork, contractAddr)) {
        ownedTokenIds.push(tokenId);
        found++;
      }
      modalStatusText.textContent = `Fetching your tokens…\nChecked: ${checked} / ${total}\nFound: ${found}`;
    }

    if (!ownedTokenIds.length) {
      modalLoadingAnimation.style.display = 'none';
      modalStatusText.textContent = 'You own no tokens in this contract.';
      setTimeout(() => closeModal(), 1500);
      return;
    }

    const tokensWithMetadata = await Promise.all(
      ownedTokenIds.map(tokenId => fetchGalleryTokenMetadata(tokenId, selectedNetwork, contractAddr))
    );

    takerTokensGrid.innerHTML = '';
    tokensWithMetadata.forEach(token => {
      const div = document.createElement('div');
      div.className = 'token-item';

      const label = document.createElement('label');
      label.textContent = `ID: ${token.tokenId}`;
      label.style.fontSize = '0.7em';
      label.style.fontWeight = 'bold';
      label.style.marginBottom = '5px';

      const img = document.createElement('img');
      img.src = token.img || 'placeholder.png';
      img.alt = token.name || 'Token Image';
      img.style.maxWidth = '140px';
      img.style.display = 'block';
      img.style.borderRadius = '3px';

      const nameLabel = document.createElement('label');
      nameLabel.textContent = token.name || 'Untitled';
      nameLabel.style.fontSize = '0.7em';
      nameLabel.style.marginTop = '5px';
      nameLabel.style.wordWrap = 'break-word';

      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'takerToken';
      radio.value = token.tokenId;
      radio.style.marginTop = '8px';

      radio.addEventListener('change', () => {
        selectedTakerTokenId = parseInt(radio.value);
        selectedTakerTokenMaxAmount = 1;
        depositOfferBtn.disabled = false;
      });

      div.appendChild(label);
      div.appendChild(img);
      div.appendChild(nameLabel);
      div.appendChild(radio);

      takerTokensGrid.appendChild(div);
    });

    setTimeout(() => closeModal(), 500);

  } catch (err) {
    console.error(err);
    modalLoadingAnimation.style.display = 'none';
    modalStatusText.textContent = 'Failed to fetch or display your tokens: ' + err.message;
    setTimeout(() => closeModal(), 2500);
  }
});

sendOfferBtn.addEventListener('click', async () => {
  console.log('Send offer clicked, selectedTokenId:', selectedTokenId);
  
  if (selectedTokenId == null) {
    alert('Select a token first');
    return;
  }
  if (!walletManager || !connectedAddress) {
    alert('Connect wallet first');
    return;
  }
  const contractAddr = makerContractInput.value.trim();
  const takerAddress = artistAddressInput.value.trim();
  
  if (!takerAddress) {
    alert('Taker address is required');
    return;
  }

  const tokenId = selectedTokenId;
  const qty = parseInt(quantitySelect.value);
  const escrowAddress = NETWORKS[selectedNetwork].contract;

  lastEscrowSubmission = sendOfferBtn.onclick;

  try {
    const isOperator = await isOperatorForToken(
      walletManager,
      connectedAddress,
      escrowAddress,
      tokenId,
      contractAddr
    );

    const fa2Contract = await walletManager.tezos.wallet.at(contractAddr);
    const escrowContract = await walletManager.tezos.wallet.at(escrowAddress);

    const escrowCall = escrowContract.methods.init_escrow(takerAddress, qty, contractAddr, tokenId);

    if (!isOperator) {
      const updateOperatorsParam = {
        add_operator: {
          owner: connectedAddress,
          operator: escrowAddress,
          token_id: tokenId,
        },
      };

      const batch = walletManager.tezos.wallet.batch()
        .withContractCall(fa2Contract.methods.update_operators([updateOperatorsParam]))
        .withContractCall(escrowCall);

      openModal('Sending transaction with operator update...');
      const op = await batch.send();
      await op.confirmation();
    } else {
      openModal('Sending transaction...');
      const op = await escrowCall.send();
      await op.confirmation();
    }

    modalLoadingAnimation.style.display = 'none';
    modalStatusText.textContent = 'Offer sent successfully!';
    modalCloseBtn.style.display = 'inline-block';
    resetMakerForm();
  } catch (err) {
    console.error(err);
    if (err.message && err.message.includes('update_operators')) {
      operatorModalError.textContent = 'Operator approval failed: ' + err.message;
      operatorModalError.style.display = 'block';
      operatorCheckModal.style.display = 'flex';
      modalLoadingAnimation.style.display = 'none';
    } else {
      modalLoadingAnimation.style.display = 'none';
      modalStatusText.textContent = 'Failed to send offer: ' + err.message;
      modalCloseBtn.style.display = 'inline-block';
    }
  }
});

if (depositOfferBtn) {
  depositOfferBtn.addEventListener('click', async () => {
    if (!selectedTakerTokenId == null) {
      alert('Select a token first');
      return;
    }
    if (!selectedEscrowId == null) {
      alert('No escrow selected');
      return;
    }
    if (!walletManager || !connectedAddress) {
      alert('Connect wallet first');
      return;
    }

    const contractAddr = takerContractInput.value.trim();
    const tokenId = selectedTakerTokenId;
    const qty = 1;
    const escrowAddress = NETWORKS[selectedNetwork].contract;

    lastEscrowSubmission = depositOfferBtn.onclick;

    try {
      const isOperator = await isOperatorForToken(
        walletManager,
        walletManager.address,
        escrowAddress,
        tokenId,
        contractAddr
      );

      const fa2Contract = await walletManager.tezos.wallet.at(contractAddr);
      const escrowContract = await walletManager.tezos.wallet.at(escrowAddress);

      const depositCall = escrowContract.methods.taker_deposit(selectedEscrowId, qty, contractAddr, tokenId);

      if (!isOperator) {
        const updateOperatorsParam = {
          add_operator: {
            owner: walletManager.address,
            operator: escrowAddress,
            token_id: tokenId,
          },
        };

        const batch = walletManager.tezos.wallet.batch()
          .withContractCall(fa2Contract.methods.update_operators([updateOperatorsParam]))
          .withContractCall(depositCall);

        openModal('Depositing token with operator update...');
        const op = await batch.send();
        await op.confirmation();
      } else {
        openModal('Depositing token...');
        const op = await depositCall.send();
        await op.confirmation();
      }

      modalLoadingAnimation.style.display = 'none';
      modalStatusText.textContent = 'Token deposited successfully!';
      modalCloseBtn.style.display = 'inline-block';
      
      takerSection.style.display = 'none';
      resetTakerForm();
      
    } catch (err) {
      console.error(err);
      modalLoadingAnimation.style.display = 'none';
      modalStatusText.textContent = 'Failed to deposit: ' + err.message;
      modalCloseBtn.style.display = 'inline-block';
    }
  });
}

clearMakerBtn.addEventListener('click', resetMakerForm);

function resetMakerForm() {
  makerContractInput.value = '';
  artistAddressInput.value = '';
  quantitySelect.disabled = true;
  quantitySelect.innerHTML = '<option>1</option>';
  sendOfferBtn.disabled = true;
  makerTokensGrid.innerHTML = '';
  selectedTokenId = null;
  selectedTokenMaxAmount = 1;
  takerSection.style.display = 'none';
  resetTakerForm();
}

function resetTakerForm() {
  takerContractInput.value = '';
  takerTokensGrid.innerHTML = '';
  depositOfferBtn.disabled = true;
  selectedTakerTokenId = null;
  selectedTakerTokenMaxAmount = 1;
}

findOffersBtn.addEventListener('click', async () => {
  if (!walletManager || !connectedAddress) {
    alert('Connect wallet first');
    return;
  }
  openModal('Fetching open offers...');
  try {
    const escrowContractAddress = NETWORKS[selectedNetwork].contract;
    const allEscrows = await fetchOpenEscrows(walletManager, connectedAddress, escrowContractAddress);
    
    const activeEscrows = allEscrows.filter(e => 
      e.status !== 'CANCELLED' && e.status !== 'COMPLETED' && e.status !== 'SWAPPED'
    );

    await populateAllOffersGrid(allOffersGrid, activeEscrows);

    modalLoadingAnimation.style.display = 'none';
    modalStatusText.textContent = 'Open offers fetched';
    setTimeout(() => { closeModal(); }, 10);	
  } catch (err) {
    console.error(err);
    modalLoadingAnimation.style.display = 'none';
    modalStatusText.textContent = 'Failed to fetch offers: ' + err.message;
    modalCloseBtn.style.display = 'inline-block';
  }
});

async function populateAllOffersGrid(grid, offers) {
  grid.innerHTML = '';
  
  if (!offers.length) {
    grid.textContent = 'No offers to display';
    grid.style.display = 'block';
    return;
  }

  console.log('All offers:', offers);

  for (const offer of offers) {
    try {
      console.log('Processing offer:', offer);
      
      const div = document.createElement('div');
      div.className = 'offer-item';
      div.style.position = 'relative';

      let statusText = '';
      let statusClass = '';
      let showSwap = false;
      let showApprove = false;
      let showCancel = true;

      if (offer.role === 'maker') {
        if (offer.status === 'WAITING_TAKER_DEPOSIT') {
          statusText = 'My Offer';
          statusClass = 'status-my-offer';
        } else if (offer.status === 'WAITING_MAKER_APPROVAL') {
          statusText = 'Finalize';
          statusClass = 'status-finalize';
          showSwap = true;
          showApprove = true;
        }
      } else if (offer.role === 'taker') {
        if (offer.status === 'WAITING_TAKER_DEPOSIT') {
          statusText = 'Add Deposit';
          statusClass = 'status-add-deposit';
        } else if (offer.status === 'WAITING_MAKER_APPROVAL') {
          statusText = 'Waiting for Maker';
          statusClass = 'status-add-deposit';
          showSwap = true;
        }
      }

      const statusBadge = document.createElement('div');
      statusBadge.className = `offer-status ${statusClass}`;
      statusBadge.textContent = statusText;
      div.appendChild(statusBadge);

      const tokenContainer = document.createElement('div');
      tokenContainer.style.flex = '1';
      tokenContainer.style.display = 'flex';
      tokenContainer.style.flexDirection = 'column';
      tokenContainer.style.alignItems = 'center';
      tokenContainer.style.justifyContent = 'center';
      tokenContainer.style.position = 'relative';

      let showingMakerToken = true;

      async function renderToken(isMaker) {
        const existingEnlarge = div.querySelector('.control-enlarge');
        if (existingEnlarge) {
          existingEnlarge.remove();
        }
        
        tokenContainer.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; height: 100%; font-size: 2em;">⏳</div>';
        
        let token = isMaker ? offer.makerToken : offer.takerToken;
        
        console.log('Rendering token:', { isMaker, token });
        
        if (token && token.Some) {
          token = token.Some;
        }
        
        if (!token) {
          tokenContainer.innerHTML = '<label style="font-size: 0.7em; font-style: italic;">Waiting for token...</label>';
          return;
        }

        if (!token.token_address || token.token_id === undefined) {
          console.error('Invalid token structure:', token);
          tokenContainer.innerHTML = '<label style="font-size: 0.7em; color: red;">Invalid token data</label>';
          return;
        }

        const tokenId = token.token_id.toNumber ? token.token_id.toNumber() : token.token_id;

        const tokenMeta = await fetchGalleryTokenMetadata(
          tokenId,
          selectedNetwork,
          token.token_address
        );

        tokenContainer.innerHTML = '';

        const label = document.createElement('label');
        label.textContent = `${isMaker ? 'Maker' : 'Taker'}: ID ${tokenMeta.tokenId}`;
        label.style.fontSize = '0.7em';
        label.style.fontWeight = 'bold';
        label.style.marginBottom = '5px';

        const img = document.createElement('img');
        img.src = tokenMeta.img || 'placeholder.png';
        img.alt = tokenMeta.name || 'Token';
        img.style.maxWidth = '140px';
        img.style.display = 'block';
        img.style.borderRadius = '3px';

        const nameLabel = document.createElement('label');
        nameLabel.textContent = tokenMeta.name || 'Untitled';
        nameLabel.style.fontSize = '0.7em';
        nameLabel.style.marginTop = '5px';
        nameLabel.style.wordWrap = 'break-word';

        tokenContainer.appendChild(label);
        tokenContainer.appendChild(img);
        tokenContainer.appendChild(nameLabel);

        const enlargeBtn = document.createElement('a');
        enlargeBtn.href = `https://zeroart.app/tezos/Zeroview/art.html?contract=${token.token_address}&tokenId=${tokenId}`;
        enlargeBtn.target = '_blank';
        enlargeBtn.className = 'offer-controls control-enlarge';
        enlargeBtn.title = 'View in Zeroview';
        enlargeBtn.innerHTML = '⤢';
        enlargeBtn.style.textDecoration = 'none';
        div.appendChild(enlargeBtn);
      }

      await renderToken(showingMakerToken);
      div.appendChild(tokenContainer);

      if (showSwap && offer.takerToken) {
        const swapBtn = document.createElement('div');
        swapBtn.className = 'offer-controls control-swap';
        swapBtn.title = 'Swap View';
        swapBtn.innerHTML = '🔄';
        swapBtn.addEventListener('click', async (e) => {
          e.stopPropagation();
          showingMakerToken = !showingMakerToken;
          await renderToken(showingMakerToken);
        });
        div.appendChild(swapBtn);
      }

      if (showCancel) {
        const cancelBtn = document.createElement('div');
        cancelBtn.className = 'offer-controls control-cancel';
        cancelBtn.title = 'Cancel Offer';
        cancelBtn.innerHTML = '✕';
        cancelBtn.addEventListener('click', async (e) => {
          e.stopPropagation();
          if (!confirm('Cancel this escrow offer?')) return;
          openModal('Cancelling escrow...');
          try {
            const escrowAddress = NETWORKS[selectedNetwork].contract;
            const escrowContract = await walletManager.tezos.wallet.at(escrowAddress);
            const op = await escrowContract.methods.cancel_escrow(offer.escrowId).send();
            await op.confirmation();
            
            modalLoadingAnimation.style.display = 'none';
            modalStatusText.textContent = 'Escrow cancelled';
            modalCloseBtn.style.display = 'inline-block';
            findOffersBtn.click();
          } catch (err) {
            modalLoadingAnimation.style.display = 'none';
            modalStatusText.textContent = 'Failed to cancel escrow: ' + err.message;
            modalCloseBtn.style.display = 'inline-block';
          }
        });
        div.appendChild(cancelBtn);
      }

      if (showApprove) {
        const approveBtn = document.createElement('div');
        approveBtn.className = 'offer-controls control-approve';
        approveBtn.title = 'Approve and Finalize Swap';
        approveBtn.innerHTML = '✓';
        approveBtn.addEventListener('click', async (e) => {
          e.stopPropagation();
          if (!confirm('Approve this swap? This will execute the token exchange.')) return;
          openModal('Finalizing swap...');
          try {
            const escrowAddress = NETWORKS[selectedNetwork].contract;
            const escrowContract = await walletManager.tezos.wallet.at(escrowAddress);
            const op = await escrowContract.methods.maker_approve(offer.escrowId).send();
            await op.confirmation();
            
            modalLoadingAnimation.style.display = 'none';
            modalStatusText.textContent = 'Swap completed successfully!';
            modalCloseBtn.style.display = 'inline-block';
            findOffersBtn.click();
          } catch (err) {
            modalLoadingAnimation.style.display = 'none';
            modalStatusText.textContent = 'Failed to finalize: ' + err.message;
            modalCloseBtn.style.display = 'inline-block';
          }
        });
        div.appendChild(approveBtn);
      }

      if (statusText === 'Add Deposit') {
        div.style.cursor = 'pointer';
        div.addEventListener('click', () => {
          selectedEscrowId = offer.escrowId;
          selectedEscrowRole = 'taker';
          selectedEscrowState = offer.status;
          window.isMakerMode = false;
          takerSection.style.display = 'block';
          depositOfferBtn.disabled = false;
          resetTakerForm();
        });
      }

      grid.appendChild(div);

    } catch (err) {
      console.error('Failed to fetch metadata or render offer:', err);
    }
  }
}

function resetOffersGrids() {
  allOffersGrid.innerHTML = '';
  selectedEscrowId = null;
  selectedEscrowRole = null;
  selectedEscrowState = null;
  takerSection.style.display = 'none';
  resetTakerForm();
}